// eslint-disable-next-line boundaries/external
import { createCookie, redirect, useParams } from "react-router";
import { getQuery } from "ufo";
import type Cookies from "universal-cookie";

import { useClientContext } from "~/contexts/client-context";
import type { AuthFeatureData } from "~/core";
import type { CfProxyData } from "~/server/extract-cf-headers";

const AFF_COOKIE_NAME = "qtag";

export const affCookie = createCookie(AFF_COOKIE_NAME, {
  maxAge: 60 * 60 * 24 * 30, // 1 месяц
  httpOnly: false,
});

// в случае если код страны detectedCountry метчится с кодом страны в настройках alternative_room_settings, тогда пользователю отдается альтернативный url рума, иначе room_url
const getRoomUrlByUserIpCountry = (
  authFeatures: AuthFeatureData,
  cfProxyData: CfProxyData,
): string | undefined => {
  const roomUrl = authFeatures?.room_url ?? undefined;
  const detectedCountry = cfProxyData["cf-ipcountry"];
  const alternativeRoomSettings = authFeatures?.alternative_room_settings;

  const alternativeRoomUrl = alternativeRoomSettings?.find(
    (item) =>
      item?.alternative_room_url_settings_id?.country?.code ===
      detectedCountry.toUpperCase(),
  )?.alternative_room_url_settings_id?.alternative_room_url;

  return alternativeRoomUrl ?? roomUrl;
};

const makePlayNowUrl = ({
  lang,
  roomUrl,
  affiliate,
  authToken,
}: {
  lang?: string;
  roomUrl?: string;
  affiliate?: string;
  cookies: Cookies;
  authToken?: string;
}): string => {
  const searchParams = new URLSearchParams({
    qtaq: affiliate ?? "",
    auth: authToken ?? "",
    lang: lang ?? "",
  });

  if (roomUrl && authToken) {
    return `${roomUrl}?${searchParams}`;
  }

  return roomUrl ?? "";
};

export function usePlayNowUrl(): string {
  const { lang } = useParams();

  const { affiliate, cookies, authToken, authFeatures, cfProxyData } =
    useClientContext();
  const roomUrl = getRoomUrlByUserIpCountry(authFeatures, cfProxyData);

  return makePlayNowUrl({ lang, roomUrl, affiliate, cookies, authToken });
}

export const getAffCookie = async (
  req: Request,
): Promise<string | undefined> => {
  const cookieHeader = req.headers.get("Cookie");
  const result = await affCookie.parse(cookieHeader);

  return typeof result === "string" ? result : undefined;
};

export const createAffCookie = async (
  req: Request,
): Promise<string | undefined> => {
  const existedCookie = await getAffCookie(req);

  if (existedCookie) {
    return undefined;
  }

  const affTag = getQuery(req.url).qtag;
  if (typeof affTag !== "string") {
    return undefined;
  }

  const cookie = await affCookie.serialize(affTag);

  throw redirect(req.url, {
    headers: {
      "Set-Cookie": cookie,
    },
  });
};
